import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UiSharedModule } from './extensions/64ee2f4a3880d73de42431ffe89a3ca2d5fdeb17326191b830f99d436d2722b9/ui-shared.module';



@NgModule({
    imports: [CommonModule, UiSharedModule],
    providers: [],
})
export class SharedExtensionsModule {}
